import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ISectionProps } from "../../../../@types/Patient";
import { IPromsTableData } from "../../../../@types/Proms";
import { ChevronDown } from "../../../../assets/icons/ChevronDown";
import { ChevronUp } from "../../../../assets/icons/ChevronUp";
import { CustomIconButton } from "../../../../components/CustomIconButton";
import { DEFAULT_PAGE_SIZE } from "../../../../constants/pagination";
import { useInfiniteProms } from "../../../../hooks/queries/proms";
import useIsMobile from "../../../../hooks/useIsMobile";
import { PageTitle } from "../../../../layout/components/PageTitle";
import { PatientPromsTable } from "../PatientPromsTable";
import { NewDataCOntainer, TitleContainer } from "./PromsSection.styles";

export function PromsSection({
  patient,
  updateColapsedSections,
  collapsedSection,
}: ISectionProps) {
  const { t } = useTranslation();

  const { isMobile } = useIsMobile();

  const {
    proms,
    isError,
    isFetching,
    isRefetching,
    refetch,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
  } = useInfiniteProms(patient.id, DEFAULT_PAGE_SIZE, "Patient");

  const handleRefreshTable = () => {
    refetch();
  };

  const [showNewData, setShowNewData] = useState<boolean>(false);

  useEffect(() => {
    if (
      !isFetching &&
      !isRefetching &&
      collapsedSection.value === true &&
      proms.length > 0
    ) {
      const collapsedDate = dayjs(collapsedSection.collapsedDate);

      proms.forEach((prom: IPromsTableData) => {
        const lastCompleted = prom.lastCompleted
          ? dayjs(prom.lastCompleted)
          : dayjs("2000-01-01");

        if (lastCompleted > collapsedDate) {
          setShowNewData(true);
        }
      });
    }
  }, [proms]);

  const handleCollapseSection = () => {
    if (collapsedSection.value === true) {
      setShowNewData(false);
    }
    updateColapsedSections("promsSection");
  };

  return (
    <>
      {!isMobile && (
        <TitleContainer>
          <PageTitle>{t("patientPage_sections_prom")}</PageTitle>
          {showNewData && (
            <NewDataCOntainer>
              {t("patientPage_sections_newData")}
            </NewDataCOntainer>
          )}
          <CustomIconButton
            style={{ marginLeft: "2px" }}
            onClick={handleCollapseSection}
          >
            {collapsedSection.value ? <ChevronUp /> : <ChevronDown />}
          </CustomIconButton>
        </TitleContainer>
      )}
      <div
        style={{
          height: collapsedSection.value ? "0" : "",
          overflow: collapsedSection.value ? "hidden" : "",
        }}
      >
        <PatientPromsTable
          patientId={patient.id}
          isLoading={isFetching && !isRefetching && !isFetchingNextPage}
          isError={isError}
          content={proms}
          refreshTable={handleRefreshTable}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          fetchNextPage={fetchNextPage}
          useInfiniteScroll
        />
      </div>
    </>
  );
}
